import state from './moduleUnitState.js'
import mutations from './moduleUnitMutations.js'
import actions from './moduleUnitActions.js'
import getters from './moduleUnitGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

